import React from 'react';
import { useDispatch } from 'react-redux';
import SizeSelectorNote from '../SizeSelectorNote';
import usePdpUrlState from './pdpUrlState';
import { useBellaSelector } from 'Client/redux/hooks';
import { changeProductDetailSizeAction, fetchProductSimpleVideoIfNeeded } from 'Client/redux/productdetail/actions';
import { fetchProductSimpleColorVariants } from 'Client/redux/productdetail/colorVariants';
import { Options } from 'Client/components/Generic/Selectors/selector';
import useFeatureToggle from 'Client/hooks/useFeatureToggle';

export interface SizeOptions extends Options {
    price: string;
    originalPrice: string;
}

const useSelectProductSize = (withInlineNotes: boolean = true) => {
    const dispatch = useDispatch();
    const [{ pdpUrlIdentifier }, setListingPageState] = usePdpUrlState();
    const { p100PdpShowMoodImageFirst, shopDeliveryTimePromise } = useFeatureToggle();

    const { sizes, selectedSize, activeSimpleSKU, quantity: currentQuantity } = useBellaSelector(
        state => state.productdetails.productdetail
    );

    const sizeOptions: SizeOptions[] = sizes
        .filter(item => item.isVisible || item.filterSize === selectedSize)
        .map(size => ({
            label: size.filterSize,
            value: size.simple,
            price: size.price,
            originalPrice: size.originalPrice,
            disabled: !size.isAvailable,
            isSelected: size.simple === activeSimpleSKU,
            note: () => (
                <SizeSelectorNote quantity={size.quantity} disabled={!size.isAvailable} inline={withInlineNotes} />
            ),
        }));

    const changeProductSize = (selectedSimple: string) => {
        setListingPageState({ pdpUrlIdentifier, activeSimpleSku: selectedSimple });
        dispatch(fetchProductSimpleVideoIfNeeded(pdpUrlIdentifier, selectedSimple));
        dispatch(fetchProductSimpleColorVariants(pdpUrlIdentifier, selectedSimple));
        dispatch(
            changeProductDetailSizeAction({
                simple: selectedSimple,
                p100PdpShowMoodImageFirst: Boolean(p100PdpShowMoodImageFirst),
                shopDeliveryTimePromise: Boolean(shopDeliveryTimePromise),
            })
        );
    };

    return { changeProductSize, sizeOptions, activeSimpleSKU, selectedSize, currentQuantity };
};

export default useSelectProductSize;
